import inputWrapper from './input__wrapper';
export default inputWrapper;